import { View } from "./View";

export const CreateDefaultAccountForExistingProfile = () => {
  return <View />;
};
